export enum StockAdjustmentTiming {
  OnCompletion = 0,
  BeginningOfDay = 1,
  EndOfDay = 2,
}
